// extracted by mini-css-extract-plugin
export default {"list":"AuthInfoBegin_list__GOkfm"};